<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>User Management</v-toolbar-title>
    </v-toolbar>
    <v-tabs vertical>
      <v-tab>
        <v-icon left>mdi-account</v-icon>
        Users
      </v-tab>
      <v-tab>
        <v-icon left>mdi-lock</v-icon>
        Security Groups
      </v-tab>
      <v-tab>
        <v-icon left>mdi-access-point</v-icon>
        Access Modules
      </v-tab>
      <v-tab>
        <v-icon left>mdi-apps</v-icon>
        Applications
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <user-data-table />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <security-profile-data-table />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <access-modules-data-table />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
           Applications goes here
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import UserDataTable from "@/components/UserDataTable";
import SecurityProfileDataTable from "@/components/SecurityProfileDataTable";
import AccessModulesDataTable from "@/components/AccessModulesDataTable";

export default {
  name: "UserManagement",
  components: {
    UserDataTable,
    SecurityProfileDataTable,
    AccessModulesDataTable
  }
};
</script>
